import {Contract} from 'ethers';
import {Interface} from '@ethersproject/abi';

import useContractRead from '~hooks/useContractRead';
import PlotNFTAbi from '~abi/PlotNFT.json';
import {PlotNFT} from '~abiTypes/PlotNFT';
import env from '~utils/env';
import {mintChainId} from '~constants/chainId';

const contract = new Contract(
    env('PLOT_NFT_ADDRESS'),
    new Interface(PlotNFTAbi),
) as PlotNFT;

const usePlotNFT = (nftId: number, isPlot: boolean) => {
    const [plotNFTExists, plotNFTExistsLoading] = useContractRead(
        isPlot && {
            contract,
            method: 'exists',
            args: [nftId],
        },
        {chainId: mintChainId},
    );

    return {plotNFTExists, plotNFTExistsLoading};
};
export default usePlotNFT;
